module.exports = __webpack_public_path__ + "img/rosetta.51fe7a38.png";